export function installationBrowser(userAgent: string, platform = '', maxTouchPoints = 0) {
  return {
    appleMobile: /iPad|iPhone|iPod/.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1),
    android: /Android/i.test(userAgent),
    samsungInternet: /Android/i.test(userAgent) && /SamsungBrowser\//i.test(userAgent),
  };
}

export type InstallMode = 'none' | 'native' | 'ios' | 'samsung' | 'android-help';

export function installationMode(options: {
  browser: ReturnType<typeof installationBrowser>;
  pathname: string;
  installed: boolean;
  dismissed: boolean;
  hasPrompt: boolean;
  authenticatedDesktop: boolean;
  notificationBanner: boolean;
}): InstallMode {
  const { browser, pathname, installed, dismissed, hasPrompt, authenticatedDesktop, notificationBanner } = options;
  if (installed || dismissed || ['/signup', '/register', '/reset-password', '/install'].includes(pathname)) return 'none';
  if (authenticatedDesktop || notificationBanner) return 'none';
  // Samsung's browser-generated installer has reported Android compatibility
  // failures. Our own controls offer a Chrome handoff instead of invoking it.
  if (browser.samsungInternet) return 'samsung';
  if (browser.appleMobile) return 'ios';
  if (hasPrompt) return 'native';
  return browser.android ? 'android-help' : 'none';
}

export function chromeInstallationUrl(currentUrl: string): string {
  const url = new URL('/install', currentUrl);
  if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Expected a portal URL.');
  // Never carry password-reset tokens, invitation tokens, or email addresses
  // into a browser handoff or its fallback URL.
  return `intent://${url.host}/install#Intent;scheme=${url.protocol.slice(0, -1)};package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url.href)};end`;
}
